export const categories = [
  { id: 1, name: '热门推荐', slug: 'hot', icon: 'ri-fire-line' },
  { id: 2, name: '明星八卦', slug: 'celebrity', icon: 'ri-star-line' },
  { id: 3, name: '网红爆料', slug: 'influencer', icon: 'ri-live-line' },
  { id: 4, name: '社会热点', slug: 'social', icon: 'ri-earth-line' },
  { id: 5, name: '影视娱乐', slug: 'entertainment', icon: 'ri-film-line' },
  { id: 6, name: '综艺节目', slug: 'variety', icon: 'ri-tv-line' },
  { id: 7, name: '科技数码', slug: 'tech', icon: 'ri-smartphone-line' },
  { id: 8, name: '财经商业', slug: 'business', icon: 'ri-money-cny-circle-line' },
];

export const categoryHeaders: Record<string, { title: string; description: string; coverImage: string }> = {
  hot: {
    title: '热门推荐',
    description: '汇聚全网最热门的视频内容，每日精选不容错过的精彩视频，让你第一时间掌握热门动态',
    coverImage: 'https://readdy.ai/api/search-image?query=Trending%20entertainment%20news%20studio%20with%20warm%20red%20and%20gold%20accent%20lighting%2C%20modern%20media%20broadcast%20set%2C%20professional%20video%20production%20environment%2C%20cinematic%20atmosphere%2C%20high%20contrast%2C%20editorial%20style&width=1400&height=400&seq=cat-hot-2026&orientation=landscape',
  },
  celebrity: {
    title: '明星八卦',
    description: '最新明星动态、娱乐圈内幕爆料，带你了解台前幕后的真实故事，吃瓜第一线',
    coverImage: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20studio%20backdrop%20with%20golden%20spotlights%20and%20red%20carpet%20theme%2C%20glamorous%20atmosphere%2C%20modern%20media%20production%20set%2C%20cinematic%20lighting%2C%20editorial%20photography%20style&width=1400&height=400&seq=cat-celeb-2026&orientation=landscape',
  },
  influencer: {
    title: '网红爆料',
    description: '热门网红最新动态、直播精彩瞬间、社交媒体热点事件追踪，第一时间了解网红圈动态',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20social%20media%20content%20creation%20studio%20with%20ring%20lights%20and%20camera%20equipment%2C%20vibrant%20warm%20lighting%2C%20trendy%20aesthetic%2C%20professional%20live%20streaming%20setup%2C%20editorial%20style&width=1400&height=400&seq=cat-influ-2026&orientation=landscape',
  },
  social: {
    title: '社会热点',
    description: '关注社会热点事件，深度追踪新闻背后的故事，客观呈现事实真相',
    coverImage: 'https://readdy.ai/api/search-image?query=Newsroom%20environment%20with%20multiple%20screens%20displaying%20news%20feeds%2C%20warm%20professional%20lighting%2C%20modern%20media%20monitoring%20center%2C%20editorial%20journalism%20atmosphere%2C%20clean%20composition&width=1400&height=400&seq=cat-social-2026&orientation=landscape',
  },
  entertainment: {
    title: '影视娱乐',
    description: '最新电影电视剧资讯、票房排行、影视评论，全方位覆盖影视娱乐领域',
    coverImage: 'https://readdy.ai/api/search-image?query=Cinema%20projector%20room%20with%20warm%20ambient%20lighting%2C%20film%20reels%20and%20modern%20digital%20screening%20equipment%2C%20movie%20posters%20on%20walls%2C%20cinematic%20atmosphere%2C%20professional%20photography&width=1400&height=400&seq=cat-film-2026&orientation=landscape',
  },
  variety: {
    title: '综艺节目',
    description: '热门综艺节目最新动态、嘉宾阵容曝光、节目花絮片段，综艺迷的必备频道',
    coverImage: 'https://readdy.ai/api/search-image?query=Television%20variety%20show%20studio%20set%20with%20colorful%20stage%20lighting%2C%20audience%20seating%20area%2C%20professional%20broadcast%20equipment%2C%20entertainment%20production%20atmosphere%2C%20warm%20vibrant%20tones&width=1400&height=400&seq=cat-variety-2026&orientation=landscape',
  },
  tech: {
    title: '科技数码',
    description: '科技圈最新爆料、数码产品评测、互联网行业动态，科技爱好者的信息前沿',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20technology%20exhibition%20hall%20with%20digital%20screens%20and%20modern%20gadgets%2C%20warm%20ambient%20lighting%2C%20clean%20minimalist%20design%2C%20professional%20tech%20showcase%2C%20editorial%20photography&width=1400&height=400&seq=cat-tech-2026&orientation=landscape',
  },
  business: {
    title: '财经商业',
    description: '财经领域深度爆料、商业内幕分析、企业动态追踪，把握经济脉搏',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20financial%20district%20office%20with%20stock%20market%20data%20screens%2C%20warm%20professional%20lighting%2C%20glass%20architecture%2C%20business%20analysis%20environment%2C%20editorial%20style%20photography&width=1400&height=400&seq=cat-biz-2026&orientation=landscape',
  },
};